import Immutable from 'immutable';
import {
  EXAM_QUESTION_INPUT_TYPES,
  EXAM_QUESTION_OPTION_TYPES,
  EXAM_QUESTION_TYPES,
} from 'edrolo/constants/QuestionTypes';
import { CLASS_FEATURE_SETS } from 'core/constants';

const templates = {
  lesson: Immutable.fromJS({
    title: '',
    key_knowledge_text: '',
    wistia_section_title: '',
    chunks: [],
    _added: true,
  }),

  topic: Immutable.fromJS({
    title: '',
    _no_of_lessons: 1,
    lessons: [],
  }),

  course: Immutable.fromJS({
    parent: null,
    title: '',
    wistia_project_hashed_id: '',
    feature_sets: Object.values(CLASS_FEATURE_SETS).reduce((acc, val) => {
      acc[val] = [];
      return acc;
    }, {}),
    topics: [],
    has_textbook: false,
    year_published: '2022',
  }),

  question: {
    answer_type: EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE,
    answers: [],
    question_to_review: null,
    marking_prompt: '',
    _added: true,
  },

  answer: Immutable.fromJS({
    serial: '',
    is_correct: false,
    text: '',
    sort_order: 0,
    _added: true,
  }),

  inputField: Immutable.fromJS({
    // created_at: null,
    // updated_at: null,
    input_type: EXAM_QUESTION_INPUT_TYPES.NUMBER,
    label: '',
    prefix: '',
    suffix: '',
    x_position: null,
    y_position: null,
    // question: 'set from question.id',
    correct_options: [],
    _added: true,
  }),

  questionOption: Immutable.fromJS({
    id: null,
    // question: 'set from question.id',
    // 'created_at': null,
    // 'updated_at': null,
    option_type: EXAM_QUESTION_OPTION_TYPES.STRING_MATCH,
    sort_order: 0,
    x_offset: null,
    y_offset: null,
    width: null,
    height: null,
    value: '',
    _added: true,
  }),

  success_measure: {
    description: '',
    color_code: '',
    guiding_question_text: '',
    _added: true,
  },
};

export default templates;
